import React, { useEffect } from "react";
import { useTimer } from "react-compound-timer";

export const NewCountDown = (props) => {
  const {
    value,
    controls: { setTime, reset },
  } = useTimer({ initialTime: 0, direction: "backward" });

  useEffect(() => {
    setTime(props.waitNew);
  }, [props.waitNew, setTime]);

  return (
    <React.Fragment>
      {`${
        value?.d < 10
          ? value?.d < 0
            ? "00"
            : "0" + `${value?.d}D`
          : `${value?.d}D`
      }`}
      :
      {`${
        value?.h < 10
          ? value?.h < 0
            ? "00"
            : "0" + `${value?.h}H`
          : `${value?.h}H`
      }`}
      :
      {`${
        value?.m < 10
          ? value?.m < 0
            ? "00"
            : "0" + `${value?.m}M`
          : `${value?.m}M`
      }`}
      :
      {`${
        value?.s < 10
          ? value?.s < 0
            ? "00"
            : "0" + `${value?.s}S`
          : `${value?.s}S`
      }`}
    </React.Fragment>
  );
};

export default NewCountDown;

// import React, { Component } from "react";
// import Timer from "react-compound-timer";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// // import Moment from "moment";

// export class NewCountDown extends Component {
//   constructor() {
//     super();
//     this.state = {
//       defaultData: null,
//     };
//   }

//   componentDidMount() {
//     if (this.props.waitNew > 0) {
//       this.setState({
//         defaultData: this.props.waitNew,
//       });
//     }
//   }

//   render() {
//     return (
//       <Timer
//         initialTime={this.props.waitNew < 0 ? 0 : this.props.waitNew}
//         formatValue={(value) => `${value < 10 ? `0${value}` : value}`}
//         lastUnit="h"
//         direction="backward"
//       >
//         {() => (
//           <React.Fragment>
//             {/* <Timer.Days /> days */}
//             <Timer.Hours /> :
//             <Timer.Minutes /> :
//             <Timer.Seconds />
//             {/* <Timer.Milliseconds /> milliseconds */}
//           </React.Fragment>
//         )}
//       </Timer>
//     );
//   }
// }

// const mapStateToProps = (state) => ({});

// export default connect(mapStateToProps, null)(withRouter(NewCountDown));
